import React, { Component } from 'react'
import { string, object, bool, any, func } from 'prop-types'

export class CheckBox extends Component {
  constructor ({ checked }) {
    super()
    this.state = {
      checked: checked || false,
      isValid: true
    }
  }

  get isChecked () {
    return this.state.checked
  }

  onChange () {
    const checked = !this.state.checked
    const isValid = !this.props.required || checked
    this.setState({ checked, isValid })
    if (this.props.onChange) {
      this.props.onChange(checked, isValid)
    }
  }

  handleValidation () {
    const isValid = !this.props.required || (this.props.required && this.state.checked)
    this.setState({ isValid })
    return { isValid }
  }

  render () {
    const { name, label, style, children } = this.props
    const { isValid } = this.state
    return (
      <div style={style}>
        <input onChange={() => this.onChange()} ref={name} className='form__input__checkbox' id={name} type='checkbox' checked={this.state.checked} />
        <label className={'form__input__checkbox__label form__control' + (!isValid ? ' form__input__checkbox__label--error' : '')} htmlFor={name}>{children || label}</label>
      </div>
    )
  }
}

CheckBox.propTypes = {
  name: string,
  style: object,
  label: string,
  onChange: func,
  children: any,
  required: bool
}

CheckBox.defaultProps = {
  name: '',
  required: false,
  checked: false
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/CheckBox.js